const emptyArray: any[] = [];
const noop = () => false;

export const fallbackContextAccount = Object.freeze({
    id: null,
    account_manager: false,
    children: emptyArray,
    campaigns: emptyArray,
    sources: emptyArray,
    providers: emptyArray,
    products: emptyArray,
    client_card_fields: {},
    trade_report: false,
    equity_alert: false,
    bdc_advisor: false,
    secondary_advisor: false,
    video_conference: false,
    hasOption: noop,
    hasNioText: noop,
    hasMessenger: noop,
    hasHyundaiSupplier: noop,
    hasVehiclesModelTextOption: noop,
    hasSupplier: noop,
    isCustom: noop,
    isParent: noop,
    isPolestar: noop,
    getActiveUsers: () => emptyArray,
    getActiveUsersAndSupplierUsers: () => emptyArray,
    getAllCustomFields: () => emptyArray,
});

export const fallbackAuthUser = Object.freeze({
    account: { leads_other_division: false },
    isAdmin: noop,
    isDirector: noop,
    isBdcDirector: noop,
    isCommercialDirector: noop,
    calculator_value_visible: false,
    isAdvisor: noop,
    isBdc: noop,
    hasAdvisorSkills: noop,
    hasDivision: noop,
    hasWebOrder: noop,
});

export const fallbackAccountVehicleModels = Object.freeze({
    wanted: emptyArray,
    exchange: emptyArray,
});
